// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"venueDetails_infoRow__qf9NF","withIcon":"venueDetails_withIcon__9q0XB","text":"venueDetails_text__6Vl_5","tagCount":"venueDetails_tagCount__6JKpK"};